// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Ga8f","content":"styles_content__DmW0b"};